module.exports = __webpack_public_path__ + "media/images/icon_list/info-65a907a0d3fe103a9e8fb4ed2ce94d21.svg";